// <s-pdp-bundle>: "steamer only" vs "bundle" picker. The accessory list is always visible.
// Ticking or unticking an accessory (or changing its variant) selects the bundle option.
// Keeps the bundle total and savings line up to date with the ticked accessories.
// s-product-form.js adds the ticked input[data-bundle-line] as extra cart lines, only while the bundle option is selected.
class SPdpBundle extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('change', (event) => this.#update(event.target), { signal: this.#ac.signal });
    this.#update(null);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #format(cents) {
    const locale = document.documentElement.lang || 'nl';
    const currency = this.dataset.currency || 'EUR';
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
  }

  #update(target) {
    const bundleRadio = this.querySelector('[data-bundle-mode][value="bundle"]');

    if (target instanceof HTMLSelectElement && target.dataset.bundleVariantFor) {
      const checkbox = this.querySelector(`#${CSS.escape(target.dataset.bundleVariantFor)}`);
      if (checkbox) {
        checkbox.value = target.value;
        checkbox.checked = true;
      }
      const newImage = target.selectedOptions[0]?.dataset.image;
      const rowImage = this.querySelector(`[data-bundle-img-for="${CSS.escape(target.dataset.bundleVariantFor)}"] img`);
      if (newImage && rowImage) {
        rowImage.removeAttribute('srcset');
        rowImage.src = newImage;
      }
    }

    const touchedAccessory =
      (target instanceof HTMLInputElement && target.matches('[data-bundle-line]')) ||
      (target instanceof HTMLSelectElement && target.dataset.bundleVariantFor);
    if (touchedAccessory && bundleRadio) bundleRadio.checked = true;

    let total = Number(this.dataset.basePrice) || 0;
    let was = Number(this.dataset.baseWas) || total;
    this.querySelectorAll('input[data-bundle-line]').forEach((checkbox) => {
      if (!checkbox.checked) return;
      total += Number(checkbox.dataset.price) || 0;
      was += Number(checkbox.dataset.was) || 0;
    });

    const totalEl = this.querySelector('[data-bundle-total]');
    const wasEl = this.querySelector('[data-bundle-was]');
    if (totalEl) totalEl.textContent = this.#format(total);
    if (wasEl) {
      wasEl.textContent = this.#format(was);
      wasEl.hidden = was <= total;
    }

    const saveEl = this.querySelector('[data-bundle-save]');
    if (saveEl) {
      const show = was > total;
      saveEl.classList.toggle('hidden', !show);
      saveEl.textContent = show ? (this.dataset.saveLabel || '').replace('__AMOUNT__', this.#format(was - total)) : '';
    }
  }
}

if (!customElements.get('s-pdp-bundle')) customElements.define('s-pdp-bundle', SPdpBundle);
